import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faSync, faAddressCard, faSearch, faPhone, faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './ContactoData.css';
import baseURL from '../../url';
import NewContact from '../NewContact/NewContact';

export default function ContactoData() {
    const [contactos, setContactos] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [modalVisible, setModalVisible] = useState(false);
    const [contacto, setContacto] = useState({});

    // Edit form fields
    const [nuevoNombre, setNuevoNombre] = useState('');
    const [nuevoTelefono, setNuevoTelefono] = useState('');
    const [nuevoInstagram, setNuevoInstagram] = useState('');
    const [nuevoEmail, setNuevoEmail] = useState('');
    const [nuevaDireccion, setNuevaDireccion] = useState('');
    const [nuevofacebook, setNuevofacebook] = useState('');

    useEffect(() => {
        cargarContacto();
    }, []);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`)
            .then(res => res.json())
            .then(data => setContactos(data.contacto || []))
            .catch(err => console.error('Error al cargar contactos:', err));
    };

    const eliminarContacto = (idContacto) => {
        Swal.fire({
            title: '¿Eliminar contacto?',
            text: 'Se eliminará esta información de contacto.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc2626',
            cancelButtonColor: '#64748b',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/contactoDelete.php?idContacto=${idContacto}`, {
                    method: 'DELETE',
                })
                    .then(res => res.json())
                    .then(data => {
                        Swal.fire('¡Eliminado!', data.mensaje, 'success');
                        cargarContacto();
                    })
                    .catch(err => {
                        console.error('Error al eliminar contacto:', err);
                        toast.error('Error al eliminar');
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setContacto(item);
        setNuevoNombre(item.nombre || '');
        setNuevoTelefono(item.telefono || '');
        setNuevoInstagram(item.instagram || '');
        setNuevoEmail(item.email || '');
        setNuevaDireccion(item.direccion || '');
        setNuevofacebook(item.facebook || '');
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const handleUpdateText = (idContacto) => {
        const payload = {
            nombre: nuevoNombre !== '' ? nuevoNombre : contacto.nombre,
            telefono: nuevoTelefono !== '' ? nuevoTelefono : contacto.telefono,
            instagram: nuevoInstagram !== '' ? nuevoInstagram : contacto.instagram,
            email: nuevoEmail !== '' ? nuevoEmail : contacto.email,
            direccion: nuevaDireccion !== '' ? nuevaDireccion : contacto.direccion,
            facebook: nuevofacebook !== '' ? nuevofacebook : contacto.facebook,
        };

        fetch(`${baseURL}/contactoPut.php?idContacto=${idContacto}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    Swal.fire('Error', data.error, 'error');
                } else {
                    Swal.fire('Actualizado', data.mensaje || 'Contacto actualizado', 'success');
                    cargarContacto();
                    cerrarModal();
                }
            })
            .catch(err => toast.error(err.message));
    };

    const filtrados = contactos.filter(c => {
        const query = busqueda.toLowerCase();
        return (
            (c.nombre || '').toLowerCase().includes(query) ||
            (c.telefono || '').toString().includes(query) ||
            (c.email || '').toLowerCase().includes(query) ||
            (c.direccion || '').toLowerCase().includes(query)
        );
    });

    return (
        <div className="adminPageContainer">
            <ToastContainer />

            {/* Cabecera Principal */}
            <div className="adminHeaderSection">
                <div className="adminHeaderTitle">
                    <h2><FontAwesomeIcon icon={faAddressCard} /> Canales de Contacto</h2>
                    <p>Configura las líneas de atención, redes sociales y ubicación visible para tus clientes.</p>
                </div>
                <div className="adminHeaderActions">
                    <NewContact onContactCreated={cargarContacto} />
                    <button className="adminActionBtn" onClick={cargarContacto} title="Recargar contactos">
                        <FontAwesomeIcon icon={faSync} />
                    </button>
                </div>
            </div>

            {/* Toolbar */}
            <div className="adminToolbar">
                <div className="adminSearchBox">
                    <FontAwesomeIcon icon={faSearch} />
                    <input 
                        type="text" 
                        placeholder="Buscar por nombre, teléfono, dirección..." 
                        value={busqueda} 
                        onChange={(e) => setBusqueda(e.target.value)} 
                    />
                </div>
                <div className="categoriesSummaryPill">
                    Total: <strong>{contactos.length} sucursales/canales</strong>
                </div>
            </div>

            {/* Tabla de Contactos */}
            <div className="adminTableCard">
                <div className="adminTableResponsive">
                    <table className="adminTable">
                        <thead>
                            <tr>
                                <th style={{ width: '70px' }}># ID</th>
                                <th>Nombre / Canal</th>
                                <th>Teléfono</th>
                                <th>Email</th>
                                <th>Dirección</th>
                                <th>Redes Sociales</th>
                                <th style={{ textAlign: 'center', width: '120px' }}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtrados.length === 0 ? (
                                <tr>
                                    <td colSpan="7" className="adminEmptyRow">
                                        No se encontraron datos de contacto registrados.
                                    </td>
                                </tr>
                            ) : (
                                filtrados.map(item => (
                                    <tr key={item.idContacto}>
                                        <td><strong>#{item.idContacto}</strong></td>
                                        <td><strong>{item.nombre || 'Principal'}</strong></td>
                                        <td>
                                            {item.telefono ? (
                                                <span className="contactInfoText">
                                                    <FontAwesomeIcon icon={faPhone} /> {item.telefono}
                                                </span>
                                            ) : '-'}
                                        </td>
                                        <td>
                                            {item.email ? (
                                                <span className="contactInfoText">
                                                    <FontAwesomeIcon icon={faEnvelope} /> {item.email}
                                                </span>
                                            ) : '-'}
                                        </td>
                                        <td>
                                            {item.direccion ? (
                                                <span className="contactInfoText">
                                                    <FontAwesomeIcon icon={faMapMarkerAlt} /> {item.direccion}
                                                </span>
                                            ) : '-'}
                                        </td>
                                        <td>
                                            <div className="socialIconsGroup">
                                                {item.instagram && (
                                                    <a href={item.instagram} target="_blank" rel="noopener noreferrer" className="socialIcon instagram" title="Instagram">
                                                        <i className="fa fa-instagram"></i>
                                                    </a>
                                                )}
                                                {item.facebook && (
                                                    <a href={item.facebook} target="_blank" rel="noopener noreferrer" className="socialIcon facebook" title="Facebook">
                                                        <i className="fa fa-facebook"></i>
                                                    </a>
                                                )}
                                                {!item.instagram && !item.facebook && <span className="textMuted">-</span>}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="adminActionBtnGroup" style={{ justifyContent: 'center' }}>
                                                <button 
                                                    className="btnTableAction btnEditar" 
                                                    onClick={() => abrirModal(item)}
                                                    title="Editar contacto"
                                                >
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </button>
                                                <button 
                                                    className="btnTableAction btnBorrar" 
                                                    onClick={() => eliminarContacto(item.idContacto)}
                                                    title="Eliminar contacto"
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modal Editar Contacto */}
            {modalVisible && (
                <div className="adminModalOverlay">
                    <div className="adminModalContent modalContactoEdit">
                        <div className="adminModalHeader">
                            <h3>Editar Información de Contacto</h3>
                            <button className="adminModalClose" onClick={cerrarModal}>&times;</button>
                        </div>

                        <div className="adminModalBody">
                            <div className="formGridRow2">
                                <div className="adminFormField">
                                    <label>Nombre del Establecimiento / Titular:</label>
                                    <input 
                                        type="text" 
                                        value={nuevoNombre} 
                                        onChange={(e) => setNuevoNombre(e.target.value)} 
                                    />
                                </div>

                                <div className="adminFormField">
                                    <label>Teléfono:</label>
                                    <input 
                                        type="text" 
                                        value={nuevoTelefono} 
                                        onChange={(e) => setNuevoTelefono(e.target.value)} 
                                    />
                                </div>
                            </div>

                            <div className="formGridRow2">
                                <div className="adminFormField">
                                    <label>Correo Electrónico:</label>
                                    <input 
                                        type="email" 
                                        value={nuevoEmail} 
                                        onChange={(e) => setNuevoEmail(e.target.value)} 
                                    />
                                </div>

                                <div className="adminFormField">
                                    <label>Dirección Física:</label>
                                    <input 
                                        type="text" 
                                        value={nuevaDireccion} 
                                        onChange={(e) => setNuevaDireccion(e.target.value)} 
                                    />
                                </div>
                            </div>

                            <div className="formGridRow2">
                                <div className="adminFormField">
                                    <label>Enlace de Instagram:</label>
                                    <input 
                                        type="url" 
                                        value={nuevoInstagram} 
                                        onChange={(e) => setNuevoInstagram(e.target.value)} 
                                        placeholder="https://instagram.com/tu-restaurante"
                                    />
                                </div>

                                <div className="adminFormField">
                                    <label>Enlace de Facebook:</label>
                                    <input 
                                        type="url" 
                                        value={nuevofacebook} 
                                        onChange={(e) => setNuevofacebook(e.target.value)} 
                                        placeholder="https://facebook.com/tu-restaurante"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="adminModalFooter">
                            <button className="adminBtnSecondary" onClick={cerrarModal}>Cancelar</button>
                            <button className="adminBtnPrimary" onClick={() => handleUpdateText(contacto.idContacto)}>
                                Guardar Cambios
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
